import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import { Typography } from 'antd';
import { ProductsData } from '../../../data/product/productsData';
import '../styles.scss';
import { useNavigate } from 'react-router-dom';
import { CategoriesData } from '../../../data/categories/categoriesData';
import ProductList from './ProductList';
import UserService from '../../../utils/api/users';
import TopBar from '../global_components/TopBar2';
import LayoutPage from '../../../layouts/Main';

const { Title } = Typography;

export default function AllProducts(props) {
  let history = useNavigate();
  const { supplier } = useParams();

  const [supplierData, setSupplierData] = useState([])
  
  const productsData = ProductsData;

  const formatSupplier = (catalogName) => {
    return catalogName
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const categoriesData = CategoriesData;
  const formattedSupplier = formatSupplier(supplier);

  useEffect(() => {
    UserService.GetUserById({id: supplier}).then(resp => {
      setSupplierData(resp.data)
    })
  
    return () => {
      
    }
  }, [])
  

  return (
    <LayoutPage>
      <TopBar title={'Todos los productos HOLA'} categorie={'none'}/>
      <ProductList products={productsData} catalog={supplier} category={'Categoria'}/>
    </LayoutPage>
  );
}
